export default __webpack_public_path__ + "static/media/drawings.0ca92021.png";